import { httpClient } from "@/httpClient";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import getPharmacyID from "@/utils/pharmacy_code";
// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute, redirect } from "@tanstack/react-router";
import Component from "@/routes/(pharma)/_layout/overview/-components/component";
import { CurrentlyActiveShift, DailyItemsChecklist, RecentTransacitons, SalesByDayByHour, SalesByDayByHourData, Transactions } from "@/routes/(pharma)/_layout/overview/-data/schema";
import { Loading } from "@/layouts/loading";
import { pharmacyClient, queryClient } from "@/connect";
import { getTodayDailyItem } from "@/gen/pharmacy-PharmacyService_connectquery";
import { DailyItem } from "@/gen/dailyitems/common_pb";
import { CurrentActiveShiftResponse } from "@/gen/shifts/current_active_shift_pb";
import { ListSalesResponse } from "@/gen/sales/list_sales_pb";
import { ListPurchaseInvoicesResponse } from "@/gen/purchase_invoice/list_purchase_invoices_pb";
import { ListPurchaseOrdersResponse } from "@/gen/purchase_order/list_purchase_orders_pb";
import { Level, StockPointType } from "@/gen/auth/common_pb";

const API_URL = import.meta.env.VITE_API_URL as string

type Props = {
  recent_transactions: ListSalesResponse;
  sales_by_day_by_hour: SalesByDayByHourData;
  daily_items_checklist: DailyItem[];
  transactions: Transactions;
  currently_active_shift: CurrentActiveShiftResponse;
}

export const Route = createFileRoute("/(pharma)/_layout/overview/")({
  component: Component,
  loader: async (): Promise<Props> => {

    const level = localStorage.getItem("level");
    const stockPointType = localStorage.getItem("stockPointType");

    if (level === Level.STOCK_POINT.toString() && stockPointType === StockPointType.RECEIVING.toString()) {
      throw redirect({
        to: "/inventory",
        replace: true,
      })
    }

    const todayDailItems = await pharmacyClient.getTodayDailyItem({})
    const shiftInfo = await pharmacyClient.currentActiveShift({})
    const salesHistory = await pharmacyClient.listSales({
      page: 1,
      pageSize: 5,
      startDate: dayjs().startOf('day').unix(),
      endDate: dayjs().endOf('day').unix(),
    })

    try {
      return {
        recent_transactions: salesHistory,
        sales_by_day_by_hour: {
          today_sales: [{
            h_hour: "00:00",
            sales_count: 0,
          }],
          yesterday_sales: [{
            h_hour: "00:00",
            sales_count: 0,
          }],
        },
        daily_items_checklist: todayDailItems.dailyItems,
        transactions: {
          current_month: 0,
          last_month: 0,
          last_year: 0,
          current_year: 0,
          inventory_spends: {
            request_month_spends: 0,
            last_month_spends: 0,
          },
          total_refunds: {
            last_month_sales: {
              card_sales: 0,
              cash_sales: 0,
              insurance_sales: 0,
              total_sales: 0,
              total_sales_count: 0,
            },
            request_month_sales: {
              card_sales: 0,
              cash_sales: 0,
              insurance_sales: 0,
              total_sales: 0,
              total_sales_count: 0,
            }
          },
          total_sales: {
            last_month_sales: {
              card_sales: 0,
              cash_sales: 0,
              insurance_sales: 0,
              total_sales: 0,
              total_sales_count: 0,
            },
            request_month_sales: {
              card_sales: 0,
              cash_sales: 0,
              insurance_sales: 0,
              total_sales: 0,
              total_sales_count: 0,
            }
          },
        },
        currently_active_shift: shiftInfo
      }
    } catch (error) {
      console.log('Error:', error);
      throw new Error("API Fetch Error");
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
  errorComponent: () => <div>Loading...</div>,
});